import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`

export const ShimmerBox = styled.div<{
  width?: number
  height?: number
  circle?: boolean
}>`
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => (props.height ? `${props.height}px` : '16px')};
  border-radius: ${(props) => (props.circle ? '50%' : '4px')};
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-size: 800px 104px;
  animation: ${shimmer} 1s infinite linear;
`

export const StyleAnalyticCard = styled.div`
  border-radius: 12px;
  width: 100%;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 14px;
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: flex-start;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`

export const StyleAnalyticCardTitle = styled.div`
  height: 20px;
`

export const StatsContainer = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
`

export const StartPercentContainer = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  border-radius: 7.5px;
  padding: 2px 6px;
`

export const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
